import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, vShow as _vShow, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/testy.jpg'
import _imports_1 from '../../assets/images/testy2.jpg'
import _imports_2 from '../../assets/images/testy3.jpg'


const _withScopeId = n => (_pushScopeId("data-v-46a716e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Enviar")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "Escolha o modelo de negócio que você quer enviar essa oportunidade")
], -1))
const _hoisted_3 = { class: "card-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "title-box" }
const _hoisted_6 = { class: "title-card" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = {
  key: 0,
  class: "img-box"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "send-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column send-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, " Localização "),
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, " Por favor, forneça as seguintes informações para nos ajudar a localizar sua oportunidade ou imóvel. ")
], -1))
const _hoisted_12 = { class: "send-form-box d-flex justify-content-center align-items-center" }
const _hoisted_13 = {
  key: 0,
  class: "send-form-child"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Teste"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "send-form-child form-container" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-8" }
const _hoisted_24 = { class: "col-4" }
const _hoisted_25 = { class: "row mt-4" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "row mt-4" }
const _hoisted_28 = { class: "col-8" }
const _hoisted_29 = { class: "col-4" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = {
  key: 0,
  class: "missing-fields"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Faltam campos! Preencha todos os campos para prosseguir.", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "send-container" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column send-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, " Arquivos complementares "),
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, " Para otimizar a análise e desempenho dos nossos algoritmos, envie arquivos ou documentos complementares. ")
], -1))
const _hoisted_38 = { class: "send-form-box d-flex justify-content-center align-items-center" }
const _hoisted_39 = {
  key: 0,
  class: "send-form-child"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Teste"
}, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "send-form-child" }
const _hoisted_43 = { class: "file-upload-container" }
const _hoisted_44 = { class: "d-flex flex-column" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-upload-text" }, " Envie a localização do imóvel ", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upload" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-upload-text-info" }, " Clique para anexar um arquivo ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-upload-text-subinfo" }, " Arquivos vetoriais: .kmz, .dwg, .shp são recomendados ", -1))
const _hoisted_49 = [
  _hoisted_46,
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = { class: "file-upload-1-selected" }
const _hoisted_51 = { class: "file-upload-info" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-plus" }, null, -1))
const _hoisted_53 = { class: "file-upload-text-info-2" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "percentage-container" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "percentage-bar" }, null, -1))
const _hoisted_57 = { class: "percentage-value" }
const _hoisted_58 = { class: "d-flex flex-column" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-upload-text two" }, " Documentos complementares ", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upload" }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-upload-text-info" }, " Clique para anexar um arquivo ", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-upload-text-subinfo" }, " Exemplos: Matrícula, Boletim cadastral, IPTU, Consulta de viabilidade, Projeto arquitetônico, Cálculo financeiro ", -1))
const _hoisted_63 = [
  _hoisted_60,
  _hoisted_61,
  _hoisted_62
]
const _hoisted_64 = { class: "file-upload-2-selected" }
const _hoisted_65 = { class: "file-upload-info" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-plus" }, null, -1))
const _hoisted_67 = { class: "file-upload-text-info-2" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "percentage-container" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "percentage-bar" }, null, -1))
const _hoisted_71 = { class: "percentage-value" }
const _hoisted_72 = { class: "send-container" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column send-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, " Pronto! "),
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, " Iremos analisar sua oportunidade. ")
], -1))
const _hoisted_74 = { class: "send-form-box d-flex flex-column justify-content-around align-items-center" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "success-msg" }, " Sua oportunidade foi enviada com sucesso! ", -1))
const _hoisted_76 = { key: 0 }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"300px"},
  src: _imports_2,
  alt: "Teste"
}, null, -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "final-msg" }, " Agora será analisada por nosso algoritmo e nosso time. Você pode visualizar o status do seu envio no seu Painel. ", -1))

import Stepper from '@/components/Stepper/Stepper.vue';
import { findAllTipologies } from '@/services/tipology/tipologyService';
import { formatCep, formatNumber } from '@/helpers/mask'
import { Tipology } from '@/services/tipology/types';
import { sendNewOpportunityToBI } from '@/services/opportunity/opportunityService';
import cep from 'cep-promise';
import router from "@/router/index";

interface FormData {
  typology: string;
  city: string;
  district: string;
  cep: string;
  area: any;
  address: string;
  numberAddress: string;
  state: string;
  localizationFiles: File[];
  complementaryFiles: File[];
}

interface NewOpportunity {
  bairro: string;
  logradouro: string;
  cidade: string;
  estado: string;
  area_lote: any;
  tipo: string;
  cep: string;
  arquivos_localizacao: File[],
  arquivos_complementares: File[],
  tipo_envio: number | undefined,
}


import { defineComponent, ref, onMounted } from 'vue';
import CustomSelect from './CustomSelect.vue';
const __default__ = defineComponent({
  components: { CustomSelect },
  name: 'SendInReview',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const step = ref(1);
const loading = ref(false);
const selectedType = ref<number>();
const tipologies = ref<Tipology[]>([]);
const currentStep = ref(1);
const loadingPercentage = ref(100);
const listOfFilesLocation = ref<File[]>([]);
const listOfFilesDocs = ref<File[]>([]);
const isLoading = ref(false);
const emitter = require('tiny-emitter/instance');
const isMobile = ref(window.innerWidth <= 1100);
const isExtraSmallMobile = ref(window.innerWidth >= 320 && window.innerWidth <= 425)

const formData = ref<FormData>({
  typology: '',
  city: '',
  district: '',
  cep: '',
  area: '',
  address: '',
  numberAddress: '',
  state: '',
  localizationFiles: [],
  complementaryFiles: [],
});

const tabs = ref([
  {
    title: 'Tipo',
    isValid: false,
  },
  {
    title: 'Dados',
    isValid: false,
  },
  {
    title: 'Arquivos',
    isValid: true,
  },
  {
    title: 'Pronto!',
    isValid: true,
  },
]);

const types = [
  {
    title: 'Relatórios',
    description: 'Maximize o entendimento do seu imóvel com nossos relatórios personalizados.',
    img: 'https://locates.com.br/wp-content/uploads/2024/02/image-68.png.webp',
    iconClass: 'fa fa-chart-simple',
    key: 1,
    addTopMargin: false,
    disabled: false,
  },
  {
    title: 'Financiamento',
    description: 'Transforme terrenos em imóveis de sucesso com nosso financiamento estratégico.',
    img: 'https://locates.com.br/wp-content/uploads/2024/02/image-69.png.webp',
    iconClass: 'fa fa-dollar-sign',
    key: 3,
    addTopMargin: false,
    disabled: false,
  },
  {
    title: 'Marketplace',
    description: 'Envie sua oportunidade para nosso marketplace e tenha acesso à rede de parceiros.',
    img: 'https://locates.com.br/wp-content/uploads/2024/02/image-71.png.webp',
    iconClass: 'bi bi-compass',
    key: 2,
    addTopMargin: true,
    disabled: true,
  },
];

const opportunityToSend = ref<NewOpportunity>({
  bairro: '',
  logradouro: '',
  cidade: '',
  estado: '',
  area_lote: '',
  tipo: '',
  cep: '',
  arquivos_localizacao: [],
  arquivos_complementares: [],
  tipo_envio: undefined,
});

const typologyDefault = ref<Tipology>({ descricao: 'Escolha o tipo do imóvel', id: 0, bl_ativo: true });

// Functions - START
const setType = (type: number) => {
  selectedType.value = type;
  tabs.value[0].isValid = true;
  incrementStep();
};

const finalize = () => {
  loading.value = true;
};

const incrementStep = () => {
  step.value += 1;
};

const fillUpOpportunityToSend = () => {
  opportunityToSend.value.arquivos_localizacao = [];
  opportunityToSend.value.arquivos_complementares = [];

  if (listOfFilesLocation.value.length > 0) {
    listOfFilesLocation.value.forEach(file => {
      if(!formData.value.localizationFiles.includes(file)) {
        formData.value.localizationFiles.push(file);
      }
    });
  }
          
  if (listOfFilesDocs.value.length > 0) {
    listOfFilesDocs.value.forEach(file => {
      if(!formData.value.complementaryFiles.includes(file)) {
        formData.value.complementaryFiles.push(file);
      }
    });
  }
          
  opportunityToSend.value.bairro = formData.value.district;
  opportunityToSend.value.logradouro = `${formData.value.address}, ${formData.value.numberAddress}`;
  opportunityToSend.value.cidade = formData.value.city;
  opportunityToSend.value.estado = formData.value.state;
  opportunityToSend.value.area_lote = formData.value.area;
  opportunityToSend.value.tipo = formData.value.typology;
  opportunityToSend.value.cep = formData.value.cep;
  opportunityToSend.value.tipo_envio = selectedType.value;
  formData.value.localizationFiles.forEach(file => {
    opportunityToSend.value.arquivos_localizacao.push(file);
  });
  formData.value.complementaryFiles.forEach(file => {
    opportunityToSend.value.arquivos_complementares.push(file);
  });
}

const isFormDataComplete = (isToSend?: boolean) => {
  if (isToSend) {
    return Object.entries(opportunityToSend.value).every(([key, value]) => {
      if (key === 'arquivos_localizacao' || key === 'arquivos_complementares') {
        return true;
      }
      return Boolean(value);
    });
  }
  const isValid = Object.values(formData.value).every(value => Boolean(value));
  if (isValid) {
    tabs.value[1].isValid = true;
  }
  return isValid;
};

const handleCepInput = async () => {
  const cepValue = formData.value.cep;
  formData.value.cep = formatCep(cepValue);

  try {
    const address = await cep(cepValue);
    if (address) {
      formData.value.city = address.city;
      formData.value.district = address.neighborhood;
      formData.value.address = address.street;
      formData.value.state = address.state;
    }
  } catch (error) {
    formData.value.city = '';
    formData.value.district = '';
    formData.value.address = '';
    formData.value.state = '';
  }
};

const fetchTipologies = async (): Promise<void> => {
  try {
    tipologies.value = await findAllTipologies();
  } catch (error) {
    console.error(error);
  }
};

const removeFileLocation = (index: number) => {
  listOfFilesLocation.value.splice(index, 1);
  formData.value.localizationFiles.findIndex((file, i) => {
    if (file === listOfFilesLocation.value[index]) {
      formData.value.localizationFiles.splice(i, 1);
    }
  });
};

const removeFileDocs = (index: number) => {
  listOfFilesDocs.value.splice(index, 1);
  formData.value.complementaryFiles.findIndex((file, i) => {
    if (file === listOfFilesDocs.value[index]) {
      formData.value.complementaryFiles.splice(i, 1);
    }
  });
};

const createNewOpportunity = async () => {
  loading.value = true;
  fillUpOpportunityToSend();
  if (isFormDataComplete(true)) {
    try {
      const formData = new FormData();
      Object.entries(opportunityToSend.value).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((file) => {
            formData.append(`${key}`, file);
          });
        } else {
          formData.append(key, value);
        }
      });

      const result = await sendNewOpportunityToBI(formData);
      if (result === 'ok') {
        step.value++;
        loading.value = false;
      }
    } catch (error) {
      console.error(error);
      loading.value = false;
    }
  }
};

const goToPanel = () => {
  reset();
  router.push({ name: 'my-panel' });
}

const handleFileUpload = (index: number) => {
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.style.display = 'none';
  fileInput.addEventListener('change', (event: Event) => {
    const inputFiles = (event.target as HTMLInputElement)?.files;
    if (inputFiles && inputFiles.length > 0) {
      const selectedFile = inputFiles[0];
      if (index == 1) {
        listOfFilesLocation.value.push(selectedFile);
      } else {
        listOfFilesDocs.value.push(selectedFile);
      }
    }
  });
  document.body.appendChild(fileInput);
  fileInput.click();
};

const reset = () => {
  step.value = 1;
  loading.value = false;
  selectedType.value = 1;
  formData.value = {
    typology: '',
    city: '',
    district: '',
    cep: '',
    area: '',
    address: '',
    numberAddress: '',
    state: '',
    localizationFiles: [],
    complementaryFiles: [],
  };
  opportunityToSend.value = {
    bairro: '',
    logradouro: '',
    cidade: '',
    estado: '',
    area_lote: '',
    tipo: '',
    cep: '',
    arquivos_localizacao: [],
    arquivos_complementares: [],
    tipo_envio: undefined,
  };
  listOfFilesLocation.value = [];
  listOfFilesDocs.value = [];
  loadingPercentage.value = 100;
}; 

onMounted(() => {
  if (tipologies.value.length <= 0) {
    fetchTipologies();
  }

  window.addEventListener('resize', () => {
    isMobile.value = window.innerWidth <= 1100;
    isExtraSmallMobile.value = (window.innerWidth >= 320) && (window.innerWidth <= 425);
  });
});
// Functions - END

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(Stepper, {
      step: step.value,
      "onUpdate:step": _cache[10] || (_cache[10] = ($event: any) => ((step).value = $event)),
      loading: loading.value,
      finalize: createNewOpportunity,
      tabs: tabs.value,
      hasNextButtonAtFirstStep: false,
      doneStep: 3,
      doneText: "Enviar"
    }, {
      "1": _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(types, (type, idx) => {
            return _createElementVNode("div", {
              class: _normalizeClass(["card send-type-card col-xl-3 col-lg-3 col-md-3 col-sm-12", { 'disabled-type': type.disabled }]),
              key: idx,
              onClick: ($event: any) => (setType(type.key))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("i", {
                    class: _normalizeClass(type.iconClass)
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(type.title), 1)
                ]),
                _createElementVNode("p", _hoisted_7, _toDisplayString(type.description), 1)
              ]),
              (!isExtraSmallMobile.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: type.img,
                      class: _normalizeClass({ 'mt-4': type.addTopMargin }),
                      alt: "Tipo",
                      width: "200"
                    }, null, 10, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_4)
          }), 64))
        ])
      ]),
      "2": _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            (!isMobile.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(CustomSelect, {
                    options: tipologies.value,
                    default: typologyDefault.value,
                    onOptionSelected: _cache[0] || (_cache[0] = ($event: any) => (formData.value.typology = $event))
                  }, null, 8, ["options", "default"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "9",
                          placeholder: "CEP",
                          class: "form-control",
                          style: _normalizeStyle({ 'background-color': formData.value.cep ? '#bca9f536' : 'none' }),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.cep) = $event)),
                          onChange: handleCepInput
                        }, null, 36), [
                          [_vModelText, formData.value.cep]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        style: _normalizeStyle({ 'background-color': formData.value.address ? '#bca9f536' : 'none' }),
                        class: "form-control",
                        placeholder: "Logradouro",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.address) = $event))
                      }, null, 4), [
                        [_vModelText, formData.value.address]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        type: "string",
                        style: _normalizeStyle({ 'background-color': formData.value.numberAddress ? '#bca9f536' : 'none' }),
                        class: "form-control",
                        placeholder: "Número",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.numberAddress) = $event))
                      }, null, 4), [
                        [_vModelText, formData.value.numberAddress]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        style: _normalizeStyle({ 'background-color': formData.value.district ? '#bca9f536' : 'none' }),
                        class: "form-control",
                        placeholder: "Bairro",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.district) = $event))
                      }, null, 4), [
                        [_vModelText, formData.value.district]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        style: _normalizeStyle({ 'background-color': formData.value.city ? '#bca9f536' : 'none' }),
                        class: "form-control",
                        placeholder: "Cidade",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.city) = $event))
                      }, null, 4), [
                        [_vModelText, formData.value.city]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        style: _normalizeStyle({ 'background-color': formData.value.state ? '#bca9f536' : 'none' }),
                        class: "form-control",
                        placeholder: "UF",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.state) = $event))
                      }, null, 4), [
                        [_vModelText, formData.value.state]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        style: _normalizeStyle({ 'background-color': formData.value.area ? '#bca9f536' : 'none' }),
                        placeholder: "Área do Terreno",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.area) = $event))
                      }, null, 4), [
                        [_vModelText, formData.value.area]
                      ])
                    ])
                  ])
                ]),
                (!isFormDataComplete())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      "3": _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            (!isMobile.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("div", {
                    class: "file-upload-1",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (handleFileUpload(1)))
                  }, _hoisted_49),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listOfFilesLocation.value, (file, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _withDirectives(_createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createElementVNode("span", _hoisted_53, _toDisplayString(file.name), 1),
                          _createElementVNode("i", {
                            class: "bi bi-x",
                            onClick: ($event: any) => (removeFileLocation(index))
                          }, null, 8, _hoisted_54)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("span", _hoisted_57, _toDisplayString(loadingPercentage.value) + "%", 1)
                        ])
                      ], 512), [
                        [_vShow, listOfFilesLocation.value.length > 0]
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("div", {
                    class: "file-upload-2",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (handleFileUpload(2)))
                  }, _hoisted_63),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listOfFilesDocs.value, (file, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _withDirectives(_createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("span", _hoisted_67, _toDisplayString(file.name), 1),
                          _createElementVNode("i", {
                            class: "bi bi-x",
                            onClick: ($event: any) => (removeFileDocs(index))
                          }, null, 8, _hoisted_68)
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _createElementVNode("span", _hoisted_71, _toDisplayString(loadingPercentage.value) + "%", 1)
                        ])
                      ], 512), [
                        [_vShow, listOfFilesDocs.value.length > 0]
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      "4": _withCtx(() => [
        _createElementVNode("div", _hoisted_72, [
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, [
            _hoisted_75,
            (!isMobile.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, _hoisted_78))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              _createElementVNode("div", {
                class: _normalizeClass(["d-flex mb-5 gap-3", { 'flex-column': isMobile.value }])
              }, [
                _createElementVNode("button", {
                  class: "panel-button",
                  onClick: goToPanel
                }, "Ir para o Painel"),
                _createElementVNode("button", {
                  class: "reset-button",
                  onClick: reset
                }, "Nova oportunidade")
              ], 2)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["step", "loading", "tabs"])
  ]))
}
}

})